<span class="text-inherit strong">*</span>
